module.exports = __webpack_public_path__ + "static/media/Togepi_gaussian2.c6026ceb.png";